module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_koyo-e80b3f33adeff94259c0dc4ca662932a.jpg";